import { render, staticRenderFns } from "./DraggableIFoodTables.vue?vue&type=template&id=3ca1836e&scoped=true"
import script from "./DraggableIFoodTables.vue?vue&type=script&lang=js"
export * from "./DraggableIFoodTables.vue?vue&type=script&lang=js"
import style0 from "./DraggableIFoodTables.vue?vue&type=style&index=0&id=3ca1836e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca1836e",
  null
  
)

export default component.exports